<template>
  <div class="wrapper flex-row align-center full-parent">
    <div class="bg-block relative">
      <img
        draggable="false"
        class="full-parent swiper-lazy"
        data-src="https://mm2015.mamalaile.com.cn/e25633ab44644b41b54e0192d3227d9f.png"
      />
      <div class="swiper-lazy-preloader" />
    </div>
    <div class="info-block">
      <slideInfo
        title="持续培训#让月嫂更专业"
        desc="妈妈来了月嫂在上岗前必须通过岗前培训，包含9大模块120堂课程，掌握30项宝宝护理能力和27项宝妈护理能力。入职后每月定期考核，并继续进行针对性在职培训。"
        buttonText="找月嫂"
      />
    </div>

    <decorate :list="decorateList" />
  </div>
</template>

<script lang="ts">
import Decorate from "@/components/decorate/decorate.vue";
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: {
    slideInfo,
    Decorate,
  },

  data() {
    return {
      decorateList: [
        // { position: 'top-right', url: require('/src/assets/images/home_pic3_bg2.png'), width: 32.08 },
        { position: 'bottom-left', url: require('/src/assets/images/home_pic3_bg1@2x.png'), width: 37.76 },
      ]
    };
  }
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;

  .bg-block {
    width: 53.13vw;
    margin-left: 5.21vw;
    margin-right: 8.91vw;

    .bg {
      object-fit: cover;
    }
  }
}
</style>